import { render, staticRenderFns } from "./br-link-cell.vue?vue&type=template&id=4865181b&scoped=true"
import script from "./br-link-cell.vue?vue&type=script&lang=ts"
export * from "./br-link-cell.vue?vue&type=script&lang=ts"
import style0 from "./br-link-cell.vue?vue&type=style&index=0&id=4865181b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4865181b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4865181b')) {
      api.createRecord('4865181b', component.options)
    } else {
      api.reload('4865181b', component.options)
    }
    module.hot.accept("./br-link-cell.vue?vue&type=template&id=4865181b&scoped=true", function () {
      api.rerender('4865181b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/in-year-budget-requests/in-year-budget-requests-table/cells/br-link-cell.vue"
export default component.exports